// import "./instrument.ts";
// import { StrictMode } from "react";
// import { createRoot } from "react-dom/client";
// import "./index.css";
// import App from "./App.tsx";
// import { AuthProvider } from "react-oidc-context";
// import { reactErrorHandler } from "@sentry/react";

// const cognitoAuthConfig = {
//   authority:
//     "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_VnLqJ0g8a",
//   client_id: "16c5sdcll2cremktpi9jctcrbq",
//   redirect_uri: "https://dev.apps.datasurfr.ai", // replace with localhost:5173
//   response_type: "code",
//   scope: "email openid phone",
// };

// createRoot(document.getElementById("root")!, {
//   onUncaughtError: reactErrorHandler((error, errorInfo, eventId) => {
//     console.warn("Uncaught error", error, errorInfo.componentStack, eventId);
//   }),
//   onCaughtError: reactErrorHandler(),
//   onRecoverableError: reactErrorHandler(),
// }).render(
//   <StrictMode>
//     <AuthProvider {...cognitoAuthConfig}>
//       <App />
//     </AuthProvider>
//   </StrictMode>
// );

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuthProvider } from "react-oidc-context";
import { reactErrorHandler } from "@sentry/react";
import AppRouter from "./routes/AppRouter.tsx";
// import "./styles/index.css";
import "./instrument.ts";
import { cognitoAuthConfig } from "./helpers/config.ts";
import { ThemeProvider } from "./components/ThemeProvider.tsx";
import { SessionGuard } from "./components/SessionGuard.tsx";
import "./global.css";
createRoot(document.getElementById("root")!, {
  onUncaughtError: reactErrorHandler((error, errorInfo, eventId) => {
    console.warn("Uncaught error", error, errorInfo.componentStack, eventId);
  }),
  onCaughtError: reactErrorHandler(),
  onRecoverableError: reactErrorHandler(),
}).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider
        {...cognitoAuthConfig}
        onSigninCallback={() => {
          window.history.replaceState({}, document.title, window.location.pathname);
        }}
      >
        <SessionGuard>
          <AppRouter />
        </SessionGuard>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>
);
